<template>
  <!--
    A la cistella i al pagament (2026-10-12): quant falta per a l'enviament Estàndard gratis. El llindar el calcula el
    servidor (tiquet habitual + un quadern), així que el comprador típic veu que amb un quadern més ja hi arriba.
  -->
  <div v-if="offer" class="fs-progress fs-done font-rubik">
    <span class="fs-text">
      <b>Tens l'enviament estàndard gratis</b> fins al {{ deadline }}
    </span>
    <span class="fs-hint">És personal: val una vegada i amb el correu on el vas rebre ({{ offer.email_hint }}).</span>
  </div>
  <div v-else-if="rule" class="fs-progress font-rubik" :class="{'fs-done': remaining <= 0}">
    <template v-if="remaining > 0">
      <span class="fs-text">
        Afegeix-hi <b>{{ euros(remaining) }}</b> més i l'enviament et surt <b>gratis</b>
      </span>
      <div class="fs-bar"><div class="fs-fill" :style="{width: percent + '%'}"></div></div>
      <span class="fs-hint">
        {{ missingUnits === 1 ? 'Amb un quadern més ja hi arribes.' : `Amb ${missingUnits} quaderns més ja hi arribes.` }}
        Enviament gratis a partir de {{ euros(rule.threshold) }}.
      </span>
    </template>
    <span v-else class="fs-text">
      <b>Tens l'enviament estàndard gratis</b>
    </span>
  </div>
</template>

<script>
import {euros} from '../../../examens/widgets/dossier/dossierShop'
import {loadFreeShipping, productsTotal, offerState, offerDeadline} from '../../freeShipping'

export default {
  name: 'FreeShippingProgress',
  props: {
    items: {type: Array, default: () => []}
  },
  data() {
    return {rule: null}
  },
  computed: {
    // Enviament gratis personal del correu de cistella abandonada
    offer() {
      return offerState.offer
    },
    deadline() {
      return offerDeadline(this.offer)
    },
    total() {
      return productsTotal(this.items)
    },
    remaining() {
      return Math.round((this.rule.threshold - this.total) * 100) / 100
    },
    percent() {
      return Math.min(100, Math.max(4, this.total / this.rule.threshold * 100))
    },
    missingUnits() {
      return Math.max(1, Math.ceil(this.remaining / this.rule.unitPrice))
    }
  },
  async created() {
    try {
      this.rule = await loadFreeShipping()
    } catch (e) {
      this.rule = null
    }
  },
  methods: {euros}
}
</script>

<style scoped>
.fs-progress {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0 0 16px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #F2FBF6;
  border: 1px solid #CDEBDC;
  color: rgb(46, 56, 86);
}
.fs-text {
  font-size: 14px;
  line-height: 1.35;
}
.fs-text b {
  color: #1B8F5D;
}
.fs-bar {
  height: 8px;
  border-radius: 999px;
  background: #DDEFE6;
  overflow: hidden;
}
.fs-fill {
  height: 100%;
  border-radius: 999px;
  background: #1B8F5D;
  transition: width 0.3s ease;
}
.fs-hint {
  font-size: 12px;
  color: #5b6478;
}
.fs-done {
  text-align: center;
}
</style>
